import 'isomorphic-unfetch';
import ApolloClient from 'apollo-client';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import contentfulFragmentTypes from 'graphql/__generated__/downloaded/fragmentTypes-contentful.json';
import {
  CONTENTFUL_GRAPHQL_URL,
  CONTENTFUL_GRAPHQL_PREVIEW_URL,
  ZAPIER_GRAPHQL_URL,
} from 'graphql/constants';

const ZapierLink = new HttpLink({
  uri: ZAPIER_GRAPHQL_URL,
  credentials: 'include',
});

const ContentfulLink = new HttpLink({
  uri: CONTENTFUL_GRAPHQL_URL,
});

const ContentfulPreviewLink = new HttpLink({
  uri: CONTENTFUL_GRAPHQL_PREVIEW_URL,
});

export const getContentfulClient = (preview: boolean) =>
  new ApolloClient({
    cache: new InMemoryCache({
      fragmentMatcher: new IntrospectionFragmentMatcher({
        introspectionQueryResultData: contentfulFragmentTypes,
      }),
    }),
    link: preview ? ContentfulPreviewLink : ContentfulLink,
  });

export const ZapierClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ZapierLink,
  name: 'blog',
});
